<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
:width="width" :height="height"><title>{{title}}</title><g
fill="#111111"><path d="M2.342 16.545a.517.517 0 0 0-.869.254L.012
23.372a.517.517 0 0 0 .139.477.526.526 0 0 0 .477.139l6.572-1.46a.517.517 0 0
0 .253-.87z"/><path d="M18.044 7.051l-11.32 11.32a.26.26 0 0 0 0 .365l1.826
1.827a.526.526 0 0 0 .731 0L20.235 9.607a.515.515 0 0 0 0-.73L18.41
7.051a.259.259 0 0 0-.366 0z"/><path d="M16.949 5.591l-1.826-1.826a.517.517 0
0 0-.73 0L3.438 14.72a.515.515 0 0 0 0 .73l1.826 1.826a.26.26 0 0 0 .365
0l11.32-11.32a.258.258 0 0 0 0-.365z"/><path d="M22.792 1.209a4.136 4.136 0 0
0-5.843 0l-.731.73a.518.518 0 0 0 0 .731l5.113 5.111a.53.53 0 0 0 .73
0l.731-.73a4.135 4.135 0 0 0 0-5.842z"/></g></svg></template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: '100%',
    },
    height: {
      type: [Number, String],
      default: '100%',
    },
    title: {
      type: String,
      default: 'pencil 2',
    },
  },
};
</script>
